import { useQuery } from '@tanstack/react-query';

import { type ListClaimCodesParams, listClaimCodes } from '~/services/LuxLoyalty';

import { claimCampaignQueryKeys } from './claimCampaignQueryKeys';

interface UseListClaimCodesOptions {
  enabled?: boolean;
}

/**
 * Fetches codes for a claim campaign with optional status filter and pagination.
 */
export function useListClaimCodes(
  campaignId: string,
  params: ListClaimCodesParams,
  options: UseListClaimCodesOptions = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: claimCampaignQueryKeys.codesList(campaignId, params),
    queryFn: async ({ signal }) => {
      return await listClaimCodes(campaignId, params, { signal });
    },
    placeholderData: (previousData) => previousData,
    enabled: enabled && !!campaignId,
    retry: false,
  });
}
